import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';
import Icon from '@ant-design/icons';
import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { ReactComponent as FilterBlack } from '../../assets/icons/filter-black.svg';
import { ReactComponent as FilterApplied } from '../../assets/icons/filter-success.svg';

const FilterIcon = ({ dataIndex, tableParams }) => {
  const { theme } = useTheme();
  const getIconComponent = () => {
    if (
      tableParams?.filters?.[dataIndex] &&
      tableParams?.filters?.[dataIndex] !== ''
    ) {
      return FilterApplied;
    }
    return theme === DARK ? Filter : FilterBlack;
  };
  return <Icon component={getIconComponent()} />;
};

FilterIcon.propTypes = {
  dataIndex: PropTypes.string.isRequired,
  tableParams: PropTypes.object,
};

export default FilterIcon;
